import TicketUpdate from '../TicketUpdate';

export default function TicketUpdateView(props: any) {
  const ticket_number = props.ticket_number
  const update_number = props.update_number
  const setBlockScreen = props.setBlockScreen

  return (
    <>
      <TicketUpdate
        action='view'
        ticket_number={ticket_number}
        update_number={update_number}
        setBlockScreen={setBlockScreen}
      />

    </>
  );
}